'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LightbulbIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LightbulbIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35 35"
        id="Light-Bulb-Shine--Streamline-Ultimate"
        height="35"
        width="35"
      >
        <desc>Light Bulb Shine Streamline Icon: https://streamlinehq.com</desc>
        <g>
          <path
            d="M20.241666666666667 31.354166666666664h-5.46875a0.7291666666666666 0.7291666666666666 0 0 0 -0.6270833333333333 0.35 0.7 0.7 0 0 0 0 0.7l0.48125 0.9770833333333333A2.9166666666666665 2.9166666666666665 0 0 0 17.208333333333332 35h0.5833333333333334a2.9166666666666665 2.9166666666666665 0 0 0 2.625 -1.6187500000000001l0.48125 -0.9770833333333333a0.7 0.7 0 0 0 0 -0.7 0.7145833333333332 0.7145833333333332 0 0 0 -0.65625 -0.35Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
          <path
            d="M17.5 6.5625a1.4583333333333333 1.4583333333333333 0 0 0 1.4583333333333333 -1.4583333333333333V1.4583333333333333a1.4583333333333333 1.4583333333333333 0 0 0 -2.9166666666666665 0v3.645833333333333a1.4583333333333333 1.4583333333333333 0 0 0 1.4583333333333333 1.4583333333333333Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
          <path
            d="M30.902083333333334 5.5562499999999995a1.4583333333333333 1.4583333333333333 0 0 0 -2.05625 0L26.25 8.1375A1.4583333333333333 1.4583333333333333 0 0 0 26.25 10.208333333333332a1.4583333333333333 1.4583333333333333 0 0 0 1.0354166666666667 0.4229166666666666 1.4583333333333333 1.4583333333333333 0 0 0 1.0208333333333333 -0.4229166666666666l2.58125 -2.58125a1.4583333333333333 1.4583333333333333 0 0 0 0.014583333333333334 -2.0708333333333333Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
          <path
            d="M33.541666666666664 17.5h-2.9166666666666665a1.4583333333333333 1.4583333333333333 0 0 0 0 2.9166666666666665h2.9166666666666665a1.4583333333333333 1.4583333333333333 0 0 0 0 -2.9166666666666665Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
          <path
            d="M8.75 8.1375 6.154166666666666 5.5562499999999995a1.4583333333333333 1.4583333333333333 0 0 0 -2.05625 2.05625L6.679166666666666 10.208333333333332a1.4583333333333333 1.4583333333333333 0 0 0 1.0208333333333333 0.4229166666666666A1.4583333333333333 1.4583333333333333 0 0 0 8.75 10.208333333333332a1.4583333333333333 1.4583333333333333 0 0 0 0 -2.0708333333333333Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
          <path
            d="M4.375 17.5H1.4583333333333333a1.4583333333333333 1.4583333333333333 0 0 0 0 2.9166666666666665h2.9166666666666665a1.4583333333333333 1.4583333333333333 0 0 0 0 -2.9166666666666665Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
          <path
            d="M17.5 8.75a9.479166666666666 9.479166666666666 0 0 0 -5.410416666666666 17.25208333333333 0.7145833333333332 0.7145833333333332 0 0 1 0.30624999999999997 0.5979166666666667V27.708333333333332a1.4583333333333333 1.4583333333333333 0 0 0 1.4583333333333333 1.4583333333333333h7.291666666666666a1.4583333333333333 1.4583333333333333 0 0 0 1.4583333333333333 -1.4583333333333333v-1.1083333333333334a0.7 0.7 0 0 1 0.3208333333333333 -0.5979166666666667A9.479166666666666 9.479166666666666 0 0 0 17.5 8.75Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

LightbulbIcon.propTypes = {
  sx: PropTypes.object
}
